/**
 * sst.js — TheraTrack Attribution Script
 * Replaces SourceBuster.js. Captures UTMs, ad platform params, and click IDs.
 * Storage: localStorage + cookie hybrid (PostHog pattern).
 * Pushes tt_sst event to window.dataLayer.
 * ~90 lines, zero dependencies.
 */
(function () {
  var P = new URLSearchParams(location.search);
  var R = document.referrer;

  // --- helpers ---
  function get(k) { return P.get(k) || ''; }
  function setCookie(n, v, days) {
    document.cookie = n + '=' + encodeURIComponent(v) + ';path=/;max-age=' + (days * 86400) + ';SameSite=Lax;Secure';
  }
  function getCookie(n) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  // --- URL param extraction ---
  var utms = {
    utm_source:   get('utm_source'),
    utm_medium:   get('utm_medium'),
    utm_campaign: get('utm_campaign'),
    utm_content:  get('utm_content'),
    utm_term:     get('utm_term')
  };

  var ads = {
    ad_account:      get('utm_account'),
    ad_campaign_id:  get('cid'),
    ad_adgroup_id:   get('agid'),
    ad_creative_id:  get('creative'),
    ad_matchtype:    get('matchtype'),
    ad_network:      get('network'),
    ad_device:       get('device'),
    ad_placement:    get('placement'),
    ad_adposition:   get('adposition'),
    ad_target_id:    get('targetid'),
    ad_loc_physical: get('loc_physical'),
    ad_loc_interest: get('loc_interest'),
    ad_extension_id: get('extensionid')
  };

  var clicks = {
    click_gclid:   get('gclid'),
    click_gbraid:  get('gbraid'),
    click_wbraid:  get('wbraid'),
    click_fbclid:  get('fbclid'),
    click_msclkid: get('msclkid'),
    click_dilcg:   get('dilcg'),
    click_srsltid: get('srsltid')
  };

  // --- source classification ---
  var hasUTM = utms.utm_source || utms.utm_medium;
  var hasClick = clicks.click_gclid || clicks.click_gbraid || clicks.click_wbraid ||
                 clicks.click_fbclid || clicks.click_msclkid || clicks.click_dilcg;
  var src, mdm;
  if (hasUTM) {
    src = utms.utm_source || '(not set)';
    mdm = utms.utm_medium || '(not set)';
  } else if (hasClick) {
    src = clicks.click_fbclid ? 'facebook' : clicks.click_msclkid ? 'bing' : 'google';
    mdm = 'cpc';
  } else if (R) {
    try {
      var rh = new URL(R).hostname.replace(/^www\./, '');
      if (/google\.|bing\.|yahoo\.|duckduckgo\.|baidu\./.test(rh)) {
        src = rh.split('.')[0]; mdm = 'organic';
      } else if (rh !== location.hostname.replace(/^www\./, '')) {
        src = rh; mdm = 'referral';
      } else { src = '(direct)'; mdm = '(none)'; }
    } catch (e) { src = '(direct)'; mdm = '(none)'; }
  } else {
    src = '(direct)'; mdm = '(none)';
  }

  // --- current touch (always overwrite) ---
  var current = { utm_source: src, utm_medium: mdm, utm_campaign: utms.utm_campaign, utm_content: utms.utm_content, utm_term: utms.utm_term };
  try { localStorage.setItem('_tt_current', JSON.stringify(current)); } catch (e) {}

  // --- first touch (write-once) ---
  var first;
  try { first = JSON.parse(localStorage.getItem('_tt_first')); } catch (e) { first = null; }
  if (!first) {
    var ck = getCookie('_tt_first');
    if (ck) { try { first = JSON.parse(ck); } catch (e) { first = null; } }
  }
  if (!first) {
    first = { utm_source: src, utm_medium: mdm, utm_campaign: utms.utm_campaign, utm_content: utms.utm_content, utm_term: utms.utm_term };
    try { localStorage.setItem('_tt_first', JSON.stringify(first)); } catch (e) {}
    setCookie('_tt_first', JSON.stringify(first), 730);
  }

  // --- dataLayer push ---
  window.dataLayer = window.dataLayer || [];
  var ev = { event: 'tt_sst' };
  var f = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  for (var i = 0; i < f.length; i++) {
    ev['first_' + f[i]] = first[f[i]] || '';
    ev['current_' + f[i]] = current[f[i]] || '';
  }
  var k;
  for (k in ads) { ev[k] = ads[k]; }
  for (k in clicks) { ev[k] = clicks[k]; }
  window.dataLayer.push(ev);
})();
